export enum PermissionEnum {
  CREATE_EXTRACT = "create_extract",
  CREATE_HANDOVER = "create_handover",
  CREATE_MESSAGE = "create_message",
  CREATE_REQUEST = "create_request",
  MANAGE_COMPANIES = "manage_companies",
  MANAGE_CONTACTS = "manage_contacts",
  MANAGE_HANDOVERS = "manage_handovers",
  MANAGE_USERS = "manage_users",
  VIEW_ALL_REQUESTS = "view_all_requests",
  VIEW_ALL_COMPANIES = "view_all_companies",
  CREATE_CUSTOMER_EXTRACT = "create_customer_extract",
}

export interface IPermissionsControlledWrapper {
  children: React.ReactElement | null;
  requiredPermission: PermissionEnum;
}
